<template>
  <v-select
    :value="value"
    @input = "sendInput"
    :items="itpItems"
    item-text="ITP_NAME"
    :item-value="valueField"
    :label="label"
    :no-data-text="'Нет доступных вариантов'"
    hide-details
  ></v-select>
</template>

<script>
import { ORG_GET_DIVISION_LIST } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'orgDivisionSelect',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    org: {
      type: Object,
      default: function () {
        return {}
      }
    },
    noIdles: {
      type: Boolean,
      default: false
    },
    idMode: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Function,
      default: function (item) {
        return true
      }
    }
  },
  data () {
    return {}
  },
  watch: {
    org (val) {
      if (val) {
        this.getOrgDivisions()
      } else {
        this.sendInput(null)
      }
    }
  },
  computed: {
    valueField: {
      get: function () {
        return this.idMode ? 'ITP_ID' : 'ITP_UUID'
      }
    },
    itpItems: {
      get: function () {
        return this.$store.getters.getOrgDivisions.filter(this.filter, this)
      }
    }
  },
  methods: {
    sendInput (val) {
      this.$emit('input', val)
    },
    getOrgDivisions () {
      this.$store.dispatch(ORG_GET_DIVISION_LIST, { INST_UUID: this.org.INST_UUID, noIdles: this.noIdles })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка получения данных ' + err })
          console.log('Ошибка ', err)
        })
    }
  },
  mounted () {
    console.log('orgDivisionSelect mounted with idMode ', this.idMode, ' value field is ', this.valueField)
    this.getOrgDivisions()
  }
}
</script>
